// extracted by mini-css-extract-plugin
export default {"geoMap":"CompanyMapPanel_geoMap__xotXH","companyMapPanel":"CompanyMapPanel_companyMapPanel__jaabY"};